import { ExamType, GradeLevel, SkillType } from "../types";

export const buildPrompt = (
  grade: GradeLevel,
  skill: SkillType,
  exam: ExamType,
  userQuery: string,
): string => {
  let context = `Bạn là một gia sư môn Ngữ Văn xuất sắc, chuyên dạy học sinh lớp ${grade}. `;

  // Định hướng kỹ năng
  switch (skill) {
    case "doc":
      context +=
        "Hãy tập trung vào kỹ năng ĐỌC HIỂU (phân tích văn bản, ý nghĩa, nghệ thuật). ";
      break;
    case "viet":
      context +=
        "Hãy tập trung vào kỹ năng VIẾT (lập dàn ý, viết đoạn văn, bài văn nghị luận/thuyết minh/tự sự). ";
      break;
    case "nghe":
      context +=
        "Hãy giúp học sinh luyện kỹ năng NGHE (tóm tắt nội dung nghe được, trả lời câu hỏi từ nội dung). ";
      break;
    case "noi":
      context +=
        "Hãy giúp học sinh luyện kỹ năng NÓI (trình bày quan điểm, hùng biện, thảo luận nhóm). ";
      break;
  }

  // Định hướng thi cử
  if (exam !== "none") {
    const examMap: Record<string, string> = {
      "giua-ky": "Ôn thi Giữa Học Kỳ",
      "cuoi-ky": "Ôn thi Cuối Học Kỳ",
      "tot-nghiep-th": "Ôn thi Tốt nghiệp Tiểu học",
      "tot-nghiep-thcs": "Ôn thi Tuyển sinh vào lớp 10 (THCS)",
      "tot-nghiep-thpt": "Ôn thi Tốt nghiệp THPT Quốc gia",
    };
    context += `Mục tiêu hiện tại là: ${examMap[exam] || ""}. Hãy đưa ra kiến thức trọng tâm và dạng bài thường gặp trong kỳ thi này. `;
  }

  const prompt = `${context}\n\nCâu hỏi/Yêu cầu của học sinh: "${userQuery}"\n\nHãy trả lời chi tiết, dễ hiểu, trình bày đẹp bằng Markdown.`;

  return prompt;
};
